<template>
  <header>
    <span class="component-label">{{'&lt;' + $options.name + ' />'}}</span>
  </header>
</template>
<script>
export default {
  name: 'AccountLayoutHeader'
}
</script>



// WEBPACK FOOTER //
// src/layouts/account-layout/AccountLayoutHeader.vue